const guideTarget = (name) => `[data-futures-guide="${name}"]`;

export const futuresOnboardingSteps = [
  // 1. Trading chart — підсвічує основний графік торгів
  {
    id: "trading-chart",
    title: "futures.onboarding.trading_chart.title",
    description: "futures.onboarding.trading_chart.description",

    desktop: {
      placement: "right",
      target: guideTarget("trading-chart"),
      offsetX: 0,
      offsetY: 0,
      scroll: false,
      arrow: {
        side: "left",
        top: "50%",
      },
    },

    mobile: {
      placement: "bottom",
      target: guideTarget("trading-chart"),
      offsetX: 0,
      offsetY: 0,
      scroll: {
        viewportPercent: 5,
      },
      arrow: {
        left: "50%",
      },
    },
  },

  // 2. Asset selection — підсвічує вибір торгової пари
  {
    id: "asset-selection",
    title: "futures.onboarding.asset_selection.title",
    description: "futures.onboarding.asset_selection.description",

    desktop: {
      placement: "bottom",
      target: guideTarget("asset-selection"),
      offsetX: 0,
      offsetY: 0,
      scroll: false,

      beforeShow: {
        type: "click",
        target: guideTarget("asset-selection-backdrop"),
        delay: 250,
        optional: true,
      },
    },

    mobile: {
      placement: "bottom",
      target: guideTarget("asset-selection-mobile"),
      offsetX: 0,
      offsetY: 0,
      scroll: {
        viewportPercent: 0,
      },
      arrow: {
        side: "top",
        left: "7%",
      },

      beforeShow: {
        type: "click",
        target: guideTarget("asset-selection-backdrop"),
        delay: 250,
        optional: true,
      },
    },
  },

  // 3. Available assets — відкриває список доступних активів
  {
    id: "available-assets",
    title: "futures.onboarding.available_assets.title",
    description: "futures.onboarding.available_assets.description",

    desktop: {
      placement: "right",
      target: guideTarget("available-assets"),
      offsetX: 0,
      offsetY: 0,
      scroll: false,
      readyDelay: 200,
      arrow: {
        side: "left",
        top: "50%",
      },

      beforeShow: {
        type: "click",
        target: guideTarget("asset-selection"),
        waitFor: guideTarget("available-assets"),
        delay: 250,
      },
    },

    mobile: {
      placement: "bottom",
      target: guideTarget("available-assets"),
      offsetX: 0,
      offsetY: -180,
      scroll: false,
      readyDelay: 100,
      arrow: {
        side: "top",
        left: "50%",
      },

      beforeShow: {
        type: "click",
        target: guideTarget("asset-selection"),
        waitFor: guideTarget("available-assets"),
        delay: 250,
      },
    },
  },

  // 4. Trading panel — показує основну торгову панель
  {
    id: "trading-panel",
    title: "futures.onboarding.trading_panel.title",
    description: "futures.onboarding.trading_panel.description",

    desktop: {
      placement: "left",
      target: guideTarget("trading-panel"),
      offsetX: 0,
      offsetY: 0,
      scroll: false,
      arrow: {
        side: "left",
        top: "50%",
      },

      beforeShow: {
        type: "click",
        target: guideTarget("asset-selection-backdrop"),
        delay: 250,
        optional: true,
      },
    },

    mobile: {
      placement: "top",
      target: guideTarget("trading-panel"),
      offsetX: 0,
      offsetY: 20,
      scroll: false,
      arrow: {
        side: "top",
        left: "50%",
      },

      beforeShow: {
        type: "click",
        target: guideTarget("asset-selection-backdrop"),
        delay: 250,
        optional: true,
      },
    },
  },

  // 5. Position size — wager + chips
  {
    id: "position-size",
    title: "futures.onboarding.position_size.title",
    description: "futures.onboarding.position_size.description",

    desktop: {
      placement: "bottom",
      target: [
        guideTarget("position-size"),
        guideTarget("position-size-percentages"),
      ],
      tooltipTarget: guideTarget("position-size"),
      offsetX: 0,
      offsetY: 70,
      scroll: false,
      arrow: {
        side: "top",
        left: "50%",
      },
    },

    mobile: {
      placement: "top",
      target: [
        guideTarget("position-size"),
        guideTarget("position-size-percentages"),
      ],
      tooltipTarget: guideTarget("position-size"),
      offsetX: 0,
      offsetY: 0,
      scroll: false,
      arrow: {
        side: "top",
        left: "50%",
      },
    },
  },

  // 6. Leverage — inline slider
  {
    id: "leverage",
    title: "futures.onboarding.leverage.title",
    description: "futures.onboarding.leverage.description",

    desktop: {
      placement: "bottom",
      target: guideTarget("leverage"),
      offsetX: 0,
      offsetY: -18,
      scroll: false,
      arrow: {
        side: "top",
        left: "50%",
      },
    },

    mobile: {
      placement: "top",
      target: guideTarget("leverage"),
      offsetX: 0,
      offsetY: 12,
      scroll: false,
      arrow: {
        side: "top",
        left: "50%",
      },
    },
  },

  // 7. Take profit / Stop loss — risk settings
  {
    id: "take-profit-stop-loss",
    title: "futures.onboarding.take_profit_stop_loss.title",
    description: "futures.onboarding.take_profit_stop_loss.description",

    desktop: {
      placement: "top",
      target: guideTarget("take-profit-stop-loss"),
      offsetX: 0,
      offsetY: 20,
      scroll: false,
      arrow: {
        side: "top",
        left: "50%",
      },
    },

    mobile: {
      placement: "top",
      target: guideTarget("take-profit-stop-loss"),
      offsetX: 0,
      offsetY: 22,
      scroll: false,
      arrow: {
        side: "top",
        left: "50%",
      },
    },
  },

  // 8. Open position — Place Trade
  {
    id: "open-position",
    title: "futures.onboarding.open_position.title",
    description: "futures.onboarding.open_position.description",

    desktop: {
      placement: "top",
      target: guideTarget("open-position"),
      offsetX: 0,
      offsetY: 0,
      scroll: false,
      arrow: {
        side: "top",
        left: "50%",
      },

      beforeShow: {
        type: "scrollToTop",
        behavior: "smooth",
        delay: 300,
      },
    },

    mobile: {
      placement: "top",
      target: guideTarget("open-position"),
      offsetX: 0,
      offsetY: 0,
      scroll: false,
      arrow: {
        side: "top",
        left: "50%",
      },
    },
  },

  // 9. Open orders
  {
    id: "open-orders",
    title: "futures.onboarding.open_orders.title",
    description: "futures.onboarding.open_orders.description",

    desktop: {
      placement: "top",
      target: [
        guideTarget("open-orders-tab"),
        guideTarget("open-orders-table"),
      ],
      tooltipTarget: guideTarget("open-orders-tab"),
      offsetX: 0,
      offsetY: 0,
      arrow: {
        side: "top",
        left: "15%",
      },

      beforeShow: [
        {
          type: "click",
          target: guideTarget("open-orders-tab"),
          waitFor: guideTarget("open-orders-table"),
          delay: 250,
        },
        {
          type: "scrollIntoView",
          target: guideTarget("open-orders-tab"),
          block: "nearest",
          inline: "center",
          delay: 150,
        },
      ],
    },

    mobile: {
      placement: "top",
      target: [
        guideTarget("open-orders-tab"),
        guideTarget("open-orders-table"),
      ],
      offsetX: 0,
      offsetY: 10,
      scroll: {
        viewportPercent: 30,
      },
      arrow: {
        side: "top",
        left: "15%",
      },

      beforeShow: {
        type: "click",
        target: guideTarget("open-orders-tab"),
        waitFor: guideTarget("open-orders-table"),
        delay: 250,
      },
    },
  },

  // 12. Positions — перемикає на вкладку активних позицій
  {
    id: "positions",
    title: "futures.onboarding.positions.title",
    description: "futures.onboarding.positions.description",

    desktop: {
      placement: "top",
      target: [guideTarget("positions-tab"), guideTarget("positions-table")],
      tooltipTarget: guideTarget("positions-tab"),
      offsetX: 0,
      offsetY: 0,
      scroll: false,
      arrow: {
        side: "top",
        left: "50%",
      },

      beforeShow: [
        {
          type: "click",
          target: guideTarget("positions-tab"),
          waitFor: guideTarget("positions-table"),
          delay: 250,
        },
        {
          type: "scrollIntoView",
          target: guideTarget("positions-tab"),
          block: "nearest",
          inline: "center",
          delay: 150,
        },
      ],
    },

    mobile: {
      placement: "top",
      target: [guideTarget("positions-tab"), guideTarget("positions-table")],
      offsetX: 0,
      offsetY: 10,
      scroll: {
        viewportPercent: 30,
      },
      arrow: {
        side: "top",
        left: "50%",
      },

      beforeShow: {
        type: "click",
        target: guideTarget("positions-tab"),
        waitFor: guideTarget("positions-table"),
        delay: 250,
      },
    },
  },

  // 13. Manage position — підсвічує кнопки керування позицією
  {
    id: "manage-position",
    title: "futures.onboarding.manage_position.title",
    description: "futures.onboarding.manage_position.description",

    desktop: {
      placement: "top",
      target: [
        guideTarget("manage-position-tp-sl"),
        guideTarget("manage-position-close"),
      ],
      offsetX: -100,
      offsetY: 0,
      scroll: false,
      arrow: {
        side: "top",
        left: "80%",
      },

      beforeShow: {
        type: "click",
        target: guideTarget("positions-tab"),
        waitFor: [
          guideTarget("manage-position-tp-sl"),
          guideTarget("manage-position-close"),
        ],
        delay: 250,
      },
    },

    mobile: {
      placement: "top",
      target: guideTarget("manage-position-mobile-close"),
      offsetX: 0,
      offsetY: 0,
      scroll: {
        viewportPercent: 65,
      },
      arrow: {
        side: "top",
        left: "50%",
      },

      beforeShow: {
        type: "click",
        target: guideTarget("positions-tab"),
        waitFor: guideTarget("manage-position-mobile-close"),
        delay: 250,
      },
    },
  },

  // 14. Order history — перемикає на історію ордерів
  {
    id: "order-history",
    title: "futures.onboarding.order_history.title",
    description: "futures.onboarding.order_history.description",

    desktop: {
      placement: "top",
      target: [
        guideTarget("order-history-tab"),
        guideTarget("order-history-table"),
      ],
      tooltipTarget: guideTarget("order-history-tab"),
      offsetX: 0,
      offsetY: 0,
      scroll: false,
      arrow: {
        side: "top",
        left: "50%",
      },

      beforeShow: [
        {
          type: "click",
          target: guideTarget("order-history-tab"),
          waitFor: guideTarget("order-history-table"),
          delay: 250,
        },
        {
          type: "scrollIntoView",
          target: guideTarget("order-history-tab"),
          block: "nearest",
          inline: "center",
          delay: 150,
        },
      ],
    },

    mobile: {
      placement: "top",
      target: [
        guideTarget("order-history-tab"),
        guideTarget("order-history-table"),
      ],
      offsetX: 0,
      offsetY: 10,
      scroll: {
        viewportPercent: 30,
      },
      arrow: {
        side: "top",
        left: "80%",
      },

      beforeShow: [
        {
          type: "click",
          target: guideTarget("order-history-tab"),
          waitFor: guideTarget("order-history-table"),
          delay: 250,
        },
        {
          type: "scrollIntoView",
          target: guideTarget("order-history-tab"),
          block: "nearest",
          inline: "end",
          delay: 250,
        },
      ],
    },
  },

  // 15. Position history — останній крок, показує історію позицій
  {
    id: "position-history",
    title: "futures.onboarding.position_history.title",
    description: "futures.onboarding.position_history.description",
    isLastStep: true,

    desktop: {
      placement: "top",
      target: [
        guideTarget("position-history-tab"),
        guideTarget("position-history-table"),
      ],
      tooltipTarget: guideTarget("position-history-tab"),
      offsetX: 0,
      offsetY: 0,
      scroll: false,
      arrow: {
        side: "top",
        left: "50%",
      },

      beforeShow: [
        {
          type: "click",
          target: guideTarget("position-history-tab"),
          waitFor: guideTarget("position-history-table"),
          delay: 250,
        },
        {
          type: "scrollIntoView",
          target: guideTarget("position-history-tab"),
          block: "nearest",
          inline: "center",
          delay: 150,
        },
      ],
    },

    mobile: {
      placement: "top",
      target: [
        guideTarget("position-history-tab"),
        guideTarget("position-history-table"),
      ],
      offsetX: 0,
      offsetY: 10,
      scroll: {
        viewportPercent: 30,
      },
      arrow: {
        side: "top",
        left: "88%",
      },

      beforeShow: [
        {
          type: "click",
          target: guideTarget("position-history-tab"),
          waitFor: guideTarget("position-history-table"),
          delay: 300,
        },
        {
          type: "scrollIntoView",
          target: guideTarget("position-history-tab"),
          block: "nearest",
          inline: "center",
          delay: 250,
        },
      ],
    },
  },
];
